
import { AGREGAR_QUERY } from "../types/queryTypes";

const addQuery = query => ({
    type: AGREGAR_QUERY,
    payload: query
})


export const agregarQuery = (query) => {
    return async (dispatch) => {
        dispatch(addQuery(query))
    }
}